import { _ as _object_spread } from "@swc/helpers/_/_object_spread";
(function(IFilterOption) {
    (function(Customizations) {
        Customizations["CUSTOMIZATIONS_UNKNOWN"] = "CUSTOMIZATIONS_UNKNOWN";
        /**
     * For evergreen preorder seasons - decorate in side nav with "New!"
     */ Customizations["EVERGREEN_NEW"] = "EVERGREEN_NEW";
        /**
     * For faire fashion week preorder options - decorate in side nav with twinkle icon
     */ Customizations["FAIRE_FASHION_WEEK"] = "FAIRE_FASHION_WEEK";
    })(IFilterOption.Customizations || (IFilterOption.Customizations = {}));
    (function(SelectionState) {
        SelectionState["SELECTION_STATE_UNKNOWN"] = "SELECTION_STATE_UNKNOWN";
        /**
     * The filter option is selected. If it has sub-options, they're all selected too.
     */ SelectionState["FULLY_SELECTED"] = "FULLY_SELECTED";
        /**
     * The filter option is unselected but has selected sub-options.
     */ SelectionState["PARTIALLY_SELECTED"] = "PARTIALLY_SELECTED";
        /**
     * The filter option isn't selected. If it has sub-options, they're all unselected too.
     */ SelectionState["UNSELECTED"] = "UNSELECTED";
    })(IFilterOption.SelectionState || (IFilterOption.SelectionState = {}));
    IFilterOption.build = function(partial) {
        return _object_spread({
            sub_options: [],
            customizations: []
        }, partial !== null && partial !== void 0 ? partial : {});
    };
})(IFilterOption || (IFilterOption = {}));
export var IFilterOption;
